exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-airtable-tsx": () => import("./../../../src/pages/airtable.tsx" /* webpackChunkName: "component---src-pages-airtable-tsx" */),
  "component---src-pages-ga-4-testpage-tsx": () => import("./../../../src/pages/ga4testpage.tsx" /* webpackChunkName: "component---src-pages-ga-4-testpage-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

